/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ScanBarcodeClassicIcon32Regular = forwardRef('ScanBarcodeClassicIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M7 7a1 1 0 0 0-2 0v18a1 1 0 1 0 2 0V7Z" }),
        React.createElement("path", { d: "M10 6a1 1 0 0 1 1 1v14.914a1 1 0 1 1-2 0V7a1 1 0 0 1 1-1Z" }),
        React.createElement("path", { d: "M15 7a1 1 0 1 0-2 0v14.914a1 1 0 1 0 2 0V7Z" }),
        React.createElement("path", { d: "M18 6a1 1 0 0 1 1 1v18a1 1 0 1 1-2 0V7a1 1 0 0 1 1-1Z" }),
        React.createElement("path", { d: "M23 7a1 1 0 1 0-2 0v14.914a1 1 0 1 0 2 0V7Z" }),
        React.createElement("path", { d: "M27 7a1 1 0 1 0-2 0v18a1 1 0 1 0 2 0V7Z" })));
});
